export function SolutionSignal({ variant }: { variant: number }) {
  const mode = variant % 3;
  return (
    <svg viewBox="0 0 180 110" className="solution-signal absolute end-5 top-5 h-20 w-32 opacity-70" aria-hidden="true">
      {mode === 0 && <>
        <g fill="#aab5ff" opacity=".72">{Array.from({ length: 18 }, (_, index) => <circle key={index} cx={26 + ((index * 31) % 130)} cy={26 + ((index * 19) % 58)} r={index % 4 === 0 ? 2.2 : 1.1} />)}</g>
        <path d="M18 86 C54 56 76 96 108 64 S142 38 164 24" fill="none" stroke="#9cbcff" strokeDasharray="4 6" />
      </>}
      {mode === 1 && <>
        <path d="M16 74 C44 28 78 96 106 48 S140 26 164 40" fill="none" stroke="#aab5ff" strokeWidth="1.5" />
        <circle cx="106" cy="48" r="6" fill="none" stroke="#e9f6f8" />
        <path d="M106 34v28M92 48h28" stroke="#e9f6f8" opacity=".8" />
        <circle cx="42" cy="26" r="3" fill="#9cbcff" /><circle cx="148" cy="18" r="3" fill="#9cbcff" />
      </>}
      {mode === 2 && <>
        <path d="M20 82 68 32l44 18 48-34M20 82l56 18 36-50 48 18" fill="none" stroke="#aab5ff" />
        <path d="M68 32 76 100M112 50l48 18" stroke="#7181d4" />
        <path d="M20 82 68 32l44 18 48-34v52l-48-18-36 50z" fill="rgba(170,181,255,.12)" />
      </>}
    </svg>
  );
}
